import styled, { css } from 'styled-components/macro';
import { colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { LG_MODAL, MD_MODAL, MODAL_HEADER_HEIGHT, SM_MODAL, XLG_MODAL } from './constants';
const MODAL_SIZE_DESKTOP_OPTIONS = {
    sm: '318px',
    md: '432px',
    lg: '546px',
    xlg: '888px',
};
const MODAL_TABLET_SIZE = '534px';
export const ModalWindowWrapStyled = styled.div `
  box-sizing: border-box;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  padding: ${INDENT.none};
  width: 100%;
  max-width: calc(100% - 32px);
  height: auto;

  /* TODO - need check for all browsers */
  height: max-content;
  border-radius: 8px;
  background-color: ${colorCoreWhite1000};
  box-shadow: ${elevationTopLvl4};
  margin: 0 16px;

  ${({ isHideVisibility }) => (isHideVisibility ? 'display: none;' : 'display: flex;')};

  .gm-style-iw-chr {
    display: none;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    max-width: calc(100% - 32px);
  }

  ${ADAPTIVE.minWidth.tablet} {
    margin: 0 auto;
    max-width: ${MODAL_TABLET_SIZE};
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${({ staticModalSize }) => staticModalSize === SM_MODAL && `max-width: ${MODAL_SIZE_DESKTOP_OPTIONS.sm}`};
    ${({ staticModalSize }) => staticModalSize === MD_MODAL && `max-width: ${MODAL_SIZE_DESKTOP_OPTIONS.md}`};
    ${({ staticModalSize }) => staticModalSize === LG_MODAL && `max-width: ${MODAL_SIZE_DESKTOP_OPTIONS.lg}`};
    ${({ staticModalSize }) => staticModalSize === XLG_MODAL && `max-width: ${MODAL_SIZE_DESKTOP_OPTIONS.xlg}`};
    ${({ staticModalSize }) => !staticModalSize && `max-width: ${MODAL_SIZE_DESKTOP_OPTIONS.lg}`};
  }

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  max-height: calc(100vh - 8px);
`;
export const ModalWindowHeaderStyled = styled.div `
  position: relative;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${MODAL_HEADER_HEIGHT};
  display: flex;
  box-sizing: border-box;

  /* Stroke/Light/Under */
  box-shadow: inset 0 -1px 0 ${colorCoreGray500};

  padding: ${({ isRightToLeft }) => isRightToLeft ? `12px ${INDENT.sm} 12px 12px` : `12px 12px 12px ${INDENT.sm}`};
`;
export const ModalWindowContentStyled = styled.div `
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  padding: ${INDENT.sm};
  width: 100%;
  box-sizing: border-box;

  /* TODO: This common way; For default way and support option with using custom HTMLElement as 'portalRoot' */
  height: auto !important;

  ${({ minHeight }) => minHeight && `min-height: ${minHeight}`};
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight}`};
  ${({ maxHeight }) => maxHeight && 'overflow-y: auto'};

  ${({ staticModalSize }) => !staticModalSize &&
    css `
      ${ADAPTIVE.maxWidth.mobile} {
        height: inherit !important;
      }
    `}
`;
